import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {SingleCitation} from './SingleCitation/SingleCitation';
import styles from './style.module.scss';
import {observer} from 'mobx-react';

interface Props {
  store: CurrentPageStore;
}
export const CommonCitations = observer(({store}: Props) => {
  return <>
    {store?.analytics?.commonCitations?.length ? <div className={styles.citationsContainer}>
      <div className={styles.citationsInnerContainer} style={{maxHeight: store.focusTermsExpanded ? 'calc(100vh - 360px)' : ' 200px'}}>
        {store?.analytics?.commonCitations.map(citation => {
          return (citation.url || citation.metaDesc) && <SingleCitation citation={citation}/>;
        })}
      </div>
    </div> :
      !store?.content?.targetKeywords?.length ? <div className={styles.emptyDataBox}>
        <span className={styles.emptyDataTitle}>Please add Target Keywords to get Common Citations.</span>
      </div> : <div className={styles.emptyDataBox}>
        <span className={styles.emptyDataTitle}>No Common Citations found for these Target Keywords.</span>
      </div> }
  </>;
});
